import React from 'react';
import ReactDOM from 'react-dom/client';
import BestDealsComponent from '../components/BestDeals';
import DatabaseComponent from '../components/Database';
import QuizComponent from '../components/Quiz';

const elemeents = [
  {
    id: 'best-deals',
    data: 'best-deals-data',
    component: BestDealsComponent,
  },
  {
    id: 'database',
    data: 'database-data',
    component: DatabaseComponent,
  },
  {
    id: 'quiz',
    data: 'quiz-data',
    component: QuizComponent,
  },
];

elemeents.forEach((element) => {
  const rootElement = document.getElementById(element.id);
  const dataElement = document.getElementById(element.data);
  if(!rootElement || !dataElement) return;
  const data = JSON.parse(dataElement.textContent);

  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <element.component data={data} />
      </React.StrictMode>,
    );
  }
});